import * as React from "react";
const SvgCrownWhite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 8.108V1.402C0 .47.539.247 1.197.905L3.01 2.718a.697.697 0 0 0 .987 0L6.503.205a.697.697 0 0 1 .987 0l2.513 2.513a.697.697 0 0 0 .987 0L12.803.905C13.461.247 14 .47 14 1.402v6.713c0 2.1-1.4 3.5-3.5 3.5h-7A3.51 3.51 0 0 1 0 8.108"
    />
  </svg>
);
export default SvgCrownWhite;
